import { render, staticRenderFns } from "./ModalMessage.vue?vue&type=template&id=0266c6d6"
import script from "./ModalMessage.vue?vue&type=script&lang=js"
export * from "./ModalMessage.vue?vue&type=script&lang=js"
import style0 from "./ModalMessage.vue?vue&type=style&index=0&id=0266c6d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports